module.exports = __webpack_public_path__ + "img/Christmas Island.cd0b5887.svg";